import {API} from 'aws-amplify';
import LogRocket from 'logrocket';

function getMyInitiAtlasDb(form) {

    let myInitDb = "";
    form.search = form.search.replace(/[@.!?\\-]/g, "")

    if (process.env.REACT_APP_ARMEN_THEME == "gpa") {
        if (form.exactPh == false) {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": "gpa_explorer",
                            "text": {
                                "query": [form.search],
                                "path": {
                                    "wildcard": "*"
                                }
                            }
                        }

                    },
                        {"$limit": (form.pageSize * form.page)},
                        {"$skip": ((form.pageSize * form.page) - form.pageSize)}

                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        } else {
            myInitDb = {

                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": 'gpa_explorer',
                            "phrase": {
                                "query": [form.search],
                                "path": 'texto',
                                "slop": 1
                            }
                        }

                    },
                        {"$limit": (form.pageSize * form.page)},
                        {"$skip": ((form.pageSize * form.page) - form.pageSize)}

                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        }
    } else if (process.env.REACT_APP_ARMEN_THEME == "credz") {
        if (form.exactPh == false) {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": "default",
                            "text": {
                                "query": [form.search],
                                "path": {
                                    "wildcard": "*"
                                }
                            },
                            "highlight": {
                                "path": "texto_cliente"
                            }
                        }

                    },
                        {
                            "$project": {
                                "_id": 1,
                                "filename": 1,
                                "texto": 1,
                                "bigram_cliente": 1,
                                "bigram_telefonista": 1,
                                "score": {
                                    "$meta": "searchScore"
                                }
                            }
                        },
                        {"$limit": (form.pageSize * form.page)},
                        {"$skip": ((form.pageSize * form.page) - form.pageSize)}

                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        } else {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": 'default',
                            "phrase": {
                                "query": [form.search],
                                "path": 'texto',
                                "slop": 1
                            },
                            "highlight": {
                                "path": 'texto_cliente'
                            }
                        }

                    },
                        {
                            "$project": {
                                "_id": 1,
                                "filename": 1,
                                "texto": 1,
                                "bigram_cliente": 1,
                                "bigram_telefonista": 1,
                                "score": {
                                    "$meta": "searchScore"
                                }
                            }
                        },
                        {"$limit": (form.pageSize * form.page)},
                        {"$skip": ((form.pageSize * form.page) - form.pageSize)}

                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        }
    } else if (process.env.REACT_APP_ARMEN_THEME == "afinz") {
        if (form.exactPh == false) {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": "afinz_gold_search",
                            "text": {
                                "query": [form.search],
                                "path": {
                                    "wildcard": "*"
                                }
                            }
                        }

                    },
                        {
                            "$project":{
                                "id_cartao":"$id_cartao",
                                "cidade_destino":"$cidade_destino",
                                "courier":"$courier",
                                "data_coletado":"$data_coletado",
                                "data_status":"$data_status",
                                "regiao":"$regiao",
                                "status":"$status",
                                "uf_destino":"$uf_destino",
                                "destinatario":"$destinatario",
                                "cep":"$cep",
                                "endereco":"$endereco",
                                "idcliente":"$idcliente",
                                "telefone":"$telefone",
                                "url":"$url",
                                "cod_correios": "$cod_correios",
                                "correios":"$correios",
                                "previsao_prazo_data":"$previsao_prazo_data",
                                "informacao_adicional":"$informacao_adicional",
                                "idcliente_fiserv":"$idcliente_fiserv",
                            }
                        },
                        {"$limit": (form.pageSize * form.page)},
                        {"$skip": ((form.pageSize * form.page) - form.pageSize)}

                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        } else {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": 'afinz_gold_search',
                            "phrase": {
                                "query": [form.search],
                                "path": 'texto',
                                "slop": 1
                            }
                        }

                    },
                        {
                            "$project":{
                                "id_cartao":"$id_cartao",
                                "cidade_destino":"$cidade_destino",
                                "courier":"$courier",
                                "data_coletado":"$data_coletado",
                                "data_status":"$data_status",
                                "regiao":"$regiao",
                                "status":"$status",
                                "uf_destino":"$uf_destino",
                                "destinatario":"$destinatario",
                                "cep":"$cep",
                                "endereco":"$endereco",
                                "idcliente":"$idcliente",
                                "telefone":"$telefone",
                                "url":"$url",
                                "cod_correios": "$cod_correios",
                                "correios":"$correios",
                                "previsao_prazo_data":"$previsao_prazo_data",
                                "informacao_adicional":"$informacao_adicional",
                                "idcliente_fiserv":"$idcliente_fiserv",
                            }
                        },
                        {"$limit": (form.pageSize * form.page)},
                        {"$skip": ((form.pageSize * form.page) - form.pageSize)}

                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        }
    } else if (process.env.REACT_APP_ARMEN_THEME == "cea") {
        if (form.exactPh == false) {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": "cea_explorer",
                            "text": {
                                "query": [form.search],
                                "path": {
                                    "wildcard": "*"
                                }
                            }
                        }

                    },
                        {
                            $project: {
                                id_produto: "$id_produto",
                                id_pedido: "$id_pedido",
                                nome_produto: "$nome_produto",
                                url_produto: "$url_produto",
                                nota: "$nota",
                                regiao: "$regiao",
                                comentario: "$comentario",
                                recomenda_produto: "$recomenda_produto",
                                sentiment: "$sentiment",
                                score: {
                                    $meta: 'searchScore'
                                }
                            }
                        },
                        {"$limit": (form.pageSize * form.page)},
                        {"$skip": ((form.pageSize * form.page) - form.pageSize)}

                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        } else {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": 'cea_explorer',
                            "phrase": {
                                "query": [form.search],
                                "path": 'texto',
                                "slop": 1
                            }
                        }

                    },
                        {
                            $project: {
                                id_produto: "$id_produto",
                                id_pedido: "$id_pedido",
                                nome_produto: "$nome_produto",
                                url_produto: "$url_produto",
                                nota: "$nota",
                                regiao: "$regiao",
                                comentario: "$comentario",
                                recomenda_produto: "$recomenda_produto",
                                sentiment: "$sentiment",
                                score: {
                                    $meta: 'searchScore'
                                }
                            }
                        },
                        {"$limit": (form.pageSize * form.page)},
                        {"$skip": ((form.pageSize * form.page) - form.pageSize)}

                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        }
    } else if (process.env.REACT_APP_ARMEN_THEME == "cupcakevox") {
        if (form.exactPh == false) {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": "cupcake_explorer",
                            "text": {
                                "query": [form.search],
                                "path": {
                                    "wildcard": "*"
                                }
                            }
                        }

                    },
                        {
                            $project: {
                                id_produto: "$id_produto",
                                id_pedido: "$id_pedido",
                                nome_produto: "$nome_produto",
                                url_produto: "$url_produto",
                                nota: "$nota",
                                regiao: "$regiao",
                                comentario: "$comentario",
                                recomenda_produto: "$recomenda_produto",
                                sentiment: "$sentiment",
                                score: {
                                    $meta: 'searchScore'
                                }
                            }
                        },
                        {"$limit": (form.pageSize * form.page)},
                        {"$skip": ((form.pageSize * form.page) - form.pageSize)}

                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        } else {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": 'cupcake_explorer',
                            "phrase": {
                                "query": [form.search],
                                "path": 'texto',
                                "slop": 1
                            }
                        }

                    },
                        {
                            $project: {
                                id_produto: "$id_produto",
                                id_pedido: "$id_pedido",
                                nome_produto: "$nome_produto",
                                url_produto: "$url_produto",
                                nota: "$nota",
                                regiao: "$regiao",
                                comentario: "$comentario",
                                recomenda_produto: "$recomenda_produto",
                                sentiment: "$sentiment",
                                score: {
                                    $meta: 'searchScore'
                                }
                            }
                        },
                        {"$limit": (form.pageSize * form.page)},
                        {"$skip": ((form.pageSize * form.page) - form.pageSize)}

                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        }
    } else if (process.env.REACT_APP_ARMEN_THEME == "ccr") {
        if (form.exactPh == false) {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": "ccr_explorer",
                            "text": {
                                "query": [form.search],
                                "path": {
                                    "wildcard": "*"
                                }
                            }
                        }

                    },
                        {
                            $project: {
                                rodovia: "$rodovia",
                                km_inicial: "$km_inicial",
                                km_final: "$km_final",
                                sentido: "$sentido",
                                faixa: "$faixa",
                                extensao_m: "$extensao_m",
                                largura_m: "$largura_m",
                                espessura_m_1: "$espessura_m_1",
                                certificado_no: "$certificado_no",
                                data: "$data",
                                material: "$material",
                                cap: "$cap",
                                usina: "$usina",
                                temperatura_ambiente: "$temperatura_ambiente",
                                temperatura_saida_usina: "$temperatura_saida_usina",
                                temperatura_chegada_obra: "$temperatura_chegada_obra",
                                temperatura_lancamento: "$temperatura_lancamento",
                                temperatura_descarga: "$temperatura_descarga",
                                temperatura_compactacao: "$temperatura_compactacao",
                                perc_grau_de_compact: "$perc_grau_de_compact",
                                perc_teor_de_vazios: "$perc_teor_de_vazios",
                                teor_de_cap: "$teor_de_cap",
                            }
                        },
                        {"$limit": (form.pageSize * form.page)},
                        {"$skip": ((form.pageSize * form.page) - form.pageSize)}

                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        } else {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": 'ccr_explorer',
                            "phrase": {
                                "query": [form.search],
                                "path": 'texto',
                                "slop": 1
                            }
                        }

                    },
                        {
                            $project: {
                                rodovia: "$rodovia",
                                km_inicial: "$km_inicial",
                                km_final: "$km_final",
                                sentido: "$sentido",
                                faixa: "$faixa",
                                extensao_m: "$extensao_m",
                                largura_m: "$largura_m",
                                espessura_m_1: "$espessura_m_1",
                                certificado_no: "$certificado_no",
                                data: "$data",
                                material: "$material",
                                cap: "$cap",
                                usina: "$usina",
                                temperatura_ambiente: "$temperatura_ambiente",
                                temperatura_saida_usina: "$temperatura_saida_usina",
                                temperatura_chegada_obra: "$temperatura_chegada_obra",
                                temperatura_lancamento: "$temperatura_lancamento",
                                temperatura_descarga: "$temperatura_descarga",
                                temperatura_compactacao: "$temperatura_compactacao",
                                perc_grau_de_compact: "$perc_grau_de_compact",
                                perc_teor_de_vazios: "$perc_teor_de_vazios",
                                teor_de_cap: "$teor_de_cap",
                            }
                        },
                        {"$limit": (form.pageSize * form.page)},
                        {"$skip": ((form.pageSize * form.page) - form.pageSize)}

                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        }
    }
    return myInitDb;
}

function getMyInitiAtlasCountDb(form) {
    let myInitDb = "";
    let re = /[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]/;
    let search = form.search.split(re)
    form.search = search[0];
    //form.search = form.search.replace(/[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]/g, " ");

    if (process.env.REACT_APP_ARMEN_THEME == 'credz') {
        if (form.exactPh == false) {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": "default",
                            "text": {
                                "query": [form.search],
                                "path": {
                                    "wildcard": "*"
                                }
                            },
                            "highlight": {
                                "path": "texto_cliente"
                            }
                        },
                    },
                        {"$count": "Total"}
                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        } else {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": 'default',
                            "phrase": {
                                "query": [form.search],
                                "path": 'texto',
                                "slop": 1
                            },
                            "highlight": {
                                "path": 'texto_cliente'
                            }
                        }

                    },
                        {"$count": "Total"}
                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        }
    } else if (process.env.REACT_APP_ARMEN_THEME == 'gpa') {
        if (form.exactPh == false) {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": "gpa_explorer",
                            "text": {
                                "query": [form.search],
                                "path": {
                                    "wildcard": "*"
                                }
                            },
                        },
                    },
                        {"$count": "Total"}
                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        } else {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": 'gpa_explorer',
                            "phrase": {
                                "query": [form.search],
                                "path": 'texto',
                                "slop": 1
                            },

                        }

                    },
                        {"$count": "Total"}
                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        }
    } else if (process.env.REACT_APP_ARMEN_THEME == 'afinz') {
        if (form.exactPh == false) {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": "afinz_gold_search",
                            "text": {
                                "query": [form.search],
                                "path": {
                                    "wildcard": "*"
                                }
                            },
                        },
                    },
                        {"$count": "Total"}
                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        } else {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": 'afinz_gold_search',
                            "phrase": {
                                "query": [form.search],
                                "path": 'texto',
                                "slop": 1
                            },

                        }

                    },
                        {"$count": "Total"}
                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        }
    } else if (process.env.REACT_APP_ARMEN_THEME == 'cea') {
        if (form.exactPh == false) {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": "cea_explorer",
                            "text": {
                                "query": [form.search],
                                "path": {
                                    "wildcard": "*"
                                }
                            },
                        },
                    },
                        {"$count": "Total"}
                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        } else {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": 'cea_explorer',
                            "phrase": {
                                "query": [form.search],
                                "path": 'texto',
                                "slop": 1
                            },

                        }

                    },
                        {"$count": "Total"}
                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        }
    } else if (process.env.REACT_APP_ARMEN_THEME == 'cupcakevox') {
        if (form.exactPh == false) {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": "cupcake_explorer",
                            "text": {
                                "query": [form.search],
                                "path": {
                                    "wildcard": "*"
                                }
                            },
                        },
                    },
                        {"$count": "Total"}
                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        } else {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": 'cupcake_explorer',
                            "phrase": {
                                "query": [form.search],
                                "path": 'texto',
                                "slop": 1
                            },

                        }

                    },
                        {"$count": "Total"}
                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        }
    } else if (process.env.REACT_APP_ARMEN_THEME == 'ccr') {
        if (form.exactPh == false) {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": "ccr_explorer",
                            "text": {
                                "query": [form.search],
                                "path": {
                                    "wildcard": "*"
                                }
                            },
                        },
                    },
                        {"$count": "Total"}
                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        } else {
            myInitDb = {
                body: {
                    "clientName": "clients",
                    "database": process.env.REACT_APP_DB_ATLAS,
                    "collection": process.env.REACT_APP_DB_COLLECTION_EXPLORER,
                    "command": "aggregate",
                    "query": [{
                        "$search": {
                            "index": 'ccr_explorer',
                            "phrase": {
                                "query": [form.search],
                                "path": 'texto',
                                "slop": 1
                            },

                        }

                    },
                        {"$count": "Total"}
                    ]
                },
                headers: {
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Origin': 'http://localhost:3000',
                    'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                    drtoken: localStorage.getItem('token')
                }
            };
        }
    }
    return myInitDb;
}

export default {
    getSearch: (params = {}) =>
        API.post('dr', '/atlas', getMyInitiAtlasDb(params)).then(response => {
            console.log(response);
            return response.response;
        }).catch(err => {
            LogRocket.captureException(err);
        }),
    getCount: (params = {}) =>
        API.post('dr', '/atlas', getMyInitiAtlasCountDb(params)).then(response => {
            return response.response;
        }).catch(err => {
            LogRocket.captureException(err);
        }),
};
